import './Label-7904957c.css';

var classes = {"Label":"prc-Label-Label--LG6X"};

export { classes as default };
